import styled from 'styled-components';

export const ConnectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 2rem;
`;

export const ConnectionCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 500px;
  width: 100%;
`;

export const ConnectionHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  
  h3 {
    margin: 1rem 0 0 0;
    color: #333;
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const ConnectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ConnectionDescription = styled.div`
  p {
    margin: 0 0 1rem 0;
    color: #666;
    line-height: 1.6;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  strong {
    color: #333;
  }
`;

export const FacebookButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  
  span {
    color: #666;
    font-size: 1rem;
  }
`;
